import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { TenantConfigService } from 'src/app/shared/services/tenant-config/tenant-config.service';
import { configFeatureFlags } from 'src/app/shared/services/enum/configFeatureFlags.enum';

@Injectable({
  providedIn: 'root',
})
export class HandoverGuard implements CanActivate {
  constructor(private readonly _tenantConfigService: TenantConfigService) {}

  async canActivate(_next: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    console.log('HandoverGuard#canActivate');
    const isHandoverEnabled = await this._tenantConfigService.isFeatureFlagSet(configFeatureFlags.handover);
    console.log('HandoverGuard#canActivate isHandoverEnabled', isHandoverEnabled);
    return isHandoverEnabled ?? false;
  }
}
